<template>
    <section class="collaboration-sec container" v-if="content">
        <div class="collaboration-sec__banner">

            <picture>
                <source :srcset="content.image.webp" type="image/webp">
                <img style="width: 100%" class="collaboration-sec__banner-img"
                     :src="content.image.jpeg" :alt="content.title">
            </picture>
        </div>
        <div class="collaboration-sec__text">
            <div class="collaboration-sec__dop-text">{{ content.title }}</div>
            <h1 class="collaboration-sec__title">{{ content.description }}</h1>
            <p class="collaboration-sec__subtitle"> {{ content.surtitle }} </p>
            <div class="collaboration-sec__bnt-row">

                <a v-if="content.button.length>0" :href="content.url" @click="buttonClick" class="btnV1">{{ content.button }}</a>
            </div>
        </div>

    </section>
</template>

<script>
export default {
    props: {
        content: {
            type: Object,
        },
    },
    name: "collaboration",
    methods: {
        buttonClick() {
            if (this.$store.state.settings.site_id == 1) {
                if (typeof ym !== 'undefined') {
                    ym(80128144,'reachGoal','push-katalog-black-friday');
                } else {
                    console.log('Yandex Metrica not loaded');
                }
            }
        }
    }
}
</script>

<style scoped>

</style>
